import { ChangeDetectionStrategy, Component, HostListener, OnInit, inject } from '@angular/core';
import { AsyncPipe, DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Member } from '../../../model/member';
import { MemberStateService } from '../../../services/member-state.service';
import { PaymentService } from '../../../services/payment.service';
import { UserContextService } from '../../../services/user-context.service';
import { map, switchMap, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UnemploymentEndDate } from '../../../model/unemployment-end-date';
import { ViewState, toViewState } from '../../../model/view-state';

@Component({
    selector: 'myabvv-unemployment-end-date',
    templateUrl: './unemployment-end-date.component.html',
    styleUrls: ['./unemployment-end-date.component.css'],
    standalone: true,
    imports: [AsyncPipe, DatePipe, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnemploymentEndDateComponent implements OnInit {
  private memberStateService = inject(MemberStateService);
  private paymentService = inject(PaymentService);
  private userContext = inject(UserContextService);


  state$: Observable<ViewState<UnemploymentEndDate>>;
  isPopoverVisible = false;

  ngOnInit() {
    this.initState();
  }

  togglePopover(event: Event) {
    event.stopPropagation();
    this.isPopoverVisible = !this.isPopoverVisible;
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.isPopoverVisible = false;
  }

  getTitleKey(data: UnemploymentEndDate): string {
    return this.is79(data)
      ? 'RECENT_INFOS.insertion_benefit_end_date'
      : 'RECENT_INFOS.unemployment_end_date';
  }

  getTooltipKey(data: UnemploymentEndDate): string {
    return this.is79(data)
      ? 'RECENT_INFOS.insertion_benefit_end_date_comment'
      : 'RECENT_INFOS.unemployment_end_date_comment';
  }

  private is79(data: UnemploymentEndDate): boolean {
    const bt = data?.blockingType;
    return bt != null && String(bt).replace(/^0+/, '') === '79';
  }

  private initState() {
    const isInternalUser = this.userContext.isInternalUser();

    const endDate$ = isInternalUser
      ? this.memberStateService.getMember().pipe(
          take(1),
          switchMap((member: Member) =>
            this.paymentService.getUnemploymentEndDate(member.personalInformation.inss, member.regcode)
          )
        )
      : this.memberStateService.getMember().pipe(
          take(1),
          switchMap((member: Member) =>
            this.paymentService.getMyUnemploymentEndDate(member.regcode)
          )
        );

    this.state$ = endDate$.pipe(
      map((res: UnemploymentEndDate[]) => res?.length > 0 ? res[0] : null),
      toViewState()
    );
  }
}
